export enum StoreId {
  ANALYTICS = 'analytics',
  CITIES = 'cities',
}
